import React from "react";

function signUp() {
  return (
    <div className="min-w-screen min-h-screen w-full  font-nunito text-desc-text z-50 absolute bg-white ">
      {/* login */}
      <div className="flex justify-between ">
        <div className="p-6 lg:pl-16 lg:pr-9 md:pt-8 w-full lg:w-2/5">
          <img src="./img/logo-panelo2.png" width="170" alt="" />
          <h1 className="font-bold my-6 text-xl">Create an Account</h1>
          <p className="mb-4 text-lg">
            Already have an account?{" "}
            <a className="text-anchor-color" href="/login">
              Log in
            </a>{" "}
            instead!
          </p>
          <form class="pb-8 mb-4 ">
            <div class="mb-4 md:flex">
              <div class="mb-4 md:mr-2 md:mb-0">
                <label
                  class="block mb-2 text-sm font-bold text-gray-500"
                  for="firstName"
                >
                  First name
                </label>
                <input
                  class="w-full py-2 text-sm leading-tight text-gray-700 border-b border-main-color appearance-none focus:outline-none focus:shadow-outline"
                  id="firstName"
                  type="text"
                  placeholder="First Name"
                />
              </div>
              <div class="md:ml-2">
                <label
                  class="block mb-2 text-sm font-bold text-gray-500"
                  for="lastName"
                >
                  Last name
                </label>
                <input
                  class="w-full py-2 text-sm leading-tight text-gray-700 border-b border-main-color appearance-none focus:outline-none focus:shadow-outline"
                  id="lastName"
                  type="text"
                  placeholder="Last Name"
                />
              </div>
            </div>
            <div class="mb-2">
              <label
                class="block mb-2 text-sm font-bold text-gray-500"
                for="email"
              >
                Email Address
              </label>
              <input
                class="w-full py-2 mb-3 text-sm leading-tight text-gray-700 border-b border-main-color appearance-none focus:outline-none focus:shadow-outline"
                id="email"
                type="email"
                placeholder="Email"
              />
            </div>
            <div class="mb-2">
              <label
                class="block mb-2 text-sm font-bold text-gray-500"
                for="email"
              >
                Phone No.
              </label>
              <input
                class="w-full py-2 mb-3 text-sm leading-tight text-gray-700 border-b border-main-color appearance-none focus:outline-none focus:shadow-outline"
                id="tel"
                type="tel"
                placeholder="Phone Number"
              />
            </div>
            <div class="mb-4  ">
              <div class="mb-4 md:mb-0">
                <label
                  class="block mb-2 text-sm font-bold text-gray-500"
                  for="password"
                >
                  Password
                </label>
                <input
                  class="w-full  py-2 mb-3 text-sm leading-tight text-gray-700 border-b border-main-color appearance-none focus:outline-none focus:shadow-outline"
                  id="password"
                  type="password"
                  placeholder="******************"
                />
              </div>
              <div class="">
                <label
                  class="block mb-2 text-sm font-bold text-gray-500"
                  for="c_password"
                >
                  Confirm Password
                </label>
                <input
                  class="w-full py-1 text-sm leading-tight text-gray-700 border-b border-main-color appearance-none focus:outline-none focus:shadow-outline"
                  id="c_password"
                  type="password"
                  placeholder="******************"
                />
              </div>
            </div>
            <div class="flex items-center justify-between">
              <label class="inline-flex items-center cursor-pointer">
                <input
                  id="customCheckLogin"
                  type="checkbox"
                  class="form-checkbox border-0 rounded w-5 h-5 ease-linear transition-all duration-150"
                />
                <span class="ml-2 pt-5 text-xs md:text-sm text-blueGray-600">
                  I agree to the terms and conditions <br /> and the privacy
                  policy.
                </span>
              </label>
              <button
                class="bg-main-color hover:bg-orange-dark flex text-white font-bold py-2 px-5 md:px-9 rounded-md focus:outline-none focus:shadow-outline"
                type="button"
              >
                <p className="md:mr-2 text-sm md:text-base">Sign Up</p>
                <img
                  className="hidden md:block"
                  src="./img/right-arrow.svg"
                  width="20"
                  alt=""
                />
              </button>
            </div>
          </form>
        </div>

        {/* Login Image */}
        <div className="w-3/5 hidden lg:block">
          <img className="h-screen w-full" src="./img/login.png" alt="" />
        </div>
      </div>
    </div>
  );
}

export default signUp;
